export const movie ={
    title:"Documentary El classico",
    videoUrl:"https://www.youtube.com/embed/2WpkS9AUdLY",
    description:"Documentary El classico",
}

